import(/* webpackMode: "eager", webpackExports: ["TeamSquadPage"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(tab-layout)/squad/components/TeamSquadPage.tsx");
